import { render } from "./ModalRegistroEmail.vue?vue&type=template&id=c7befcba&scoped=true"
import script from "./ModalRegistroEmail.vue?vue&type=script&lang=js"
export * from "./ModalRegistroEmail.vue?vue&type=script&lang=js"

import "./ModalRegistroEmail.vue?vue&type=style&index=0&id=c7befcba&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7befcba"]])

export default __exports__